export default "__VITE_ASSET__67305d8b__"